jQuery(function($) {

  var l_window = parseInt($(window).width());
  var header = $('#masthead'); 

     /*  ***************************
    SCROLL FIXED MENU 
  ******************************** */
   $(window).scroll(function () {
    if(l_window > 1023){
      action_on_scroll();
    }
    });

   /* menu mobile - add */
  $( "#primary-menu > li.menu-item-has-children" ).each(function( index ) {
     var $link_txt =  $( this ).find('> a').text();
     $( this ).children('ul.sub-menu').prepend('<li class="title_sub_menu_back"><i class="icon-prev"></i>'+$link_txt+'</li>');
    
  }); 

  $( ".PresProduit.vertical" ).each(function( index ) {
    if($(this).prev().children().is('.fl-content-twocol,.img_left_txt_right')){
      $(this).prev().addClass('no_m_b');
      $(this).next().addClass('no_m_t');
      $(this).addClass('no_p_t');
   }
  });

  

  
  $( ".menu-toggle" ).click(function() {
    $('#primary-menu > li.menu-item-has-children').removeClass('focus');
  });

  $( ".title_sub_menu_back" ).click(function() {
    $(this).parent().parent().removeClass('focus');
  });


  function action_on_scroll(){
      l_window = parseInt($(window).width());
       if ($(window).scrollTop() > 50){
          header.addClass("Masthead--sticky");
          $("body").addClass('header--sticky');
        }else{
           header.removeClass("Masthead--sticky");
           $("body").removeClass('header--sticky');
        }
   }

     $('.topHome_slider').slick({
       slidesToShow: 1,
       slidesToScroll: 1,
       // adaptiveHeight: true,
       arrows: false,
       fade: true,
       autoplay:true,
       autoplaySpeed: 4000,
       focusOnSelect: false,
       pauseOnFocus:false,
       pauseOnHover:false,
       dots:false,
    });


     /* Slider formulaire de contact */
     
     $('.Contact_slider').slick({
       slidesToShow: 1,
       slidesToScroll: 1,
       // adaptiveHeight: true,
       arrows: false,
       fade: true,
       autoplay:true,
       autoplaySpeed: 4000,
       focusOnSelect: false,
       pauseOnFocus:false,
       pauseOnHover:false,
       dots:false,
    });


     /* Gamme en haut home page uniquement sur mobile */
     $('.slick_gammes_mobile').slick({
      arrows: false,
      autoplay:true,
      autoplaySpeed: 4000,
      slidesToScroll: 1,
      dots:false,
        responsive: [
            {
              breakpoint: 5000,
              settings: "unslick"
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
             {
              breakpoint: 500,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              },
            }
          ]
    }); 



    /* Block services uniqument sur mobile */
     $('.slick_hservices_mobile').slick({
      arrows: false,
      autoplay:true,
      autoplaySpeed: 4000,
      slidesToScroll: 1,
      dots:false,
      responsive: [
          {
            breakpoint: 5000,
            settings: "unslick"
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
           {
            breakpoint: 500,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            },
          }
        ]
    });


   /* Last Post Home page */
     $('.SlickHomePage').slick({
      arrows: false,
      autoplay:true,
      autoplaySpeed: 3000,
      slidesToScroll: 1,
      slidesToShow: 3,
      dots:false,
      responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
           {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            },
          }
        ]
    });


    /* Last Post Home page */
     $('.slick_gallery_case_study').slick({
      arrows: false,
      autoplay:true,
      autoplaySpeed: 3000,
      slidesToScroll: 1,
      slidesToShow: 1,
      dots:true,
    });

    /* Simple gallery dans les produits */
     $('.gallery_js, .gallery_js_product').slick({
      arrows: false,
      autoplay:true,
      autoplaySpeed: 3000,
      slidesToScroll: 1,
      slidesToShow: 1,
      dots:true,
      pauseOnFocus:false,
      pauseOnHover:false,
    });


     

    /* Slider zoom produit dans étude de cas */
     $('.Slick-ZoomProduct').slick({
        arrows: true,
        autoplay:true,
        autoplaySpeed: 3000,
        slidesToScroll: 1,
        slidesToShow: 2,
        dots:false,
         responsive: [
           {
            breakpoint: 601,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            },
          }
        ]

    });


       /* Slider zoom produit dans étude de cas */
     $('.Slick-OtherProduct').slick({
        arrows: true,
        autoplay:true,
        autoplaySpeed: 3000,
        slidesToScroll: 1,
        slidesToShow: 3,
        dots:false,
         responsive: [
           {
            breakpoint: 1023,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            },
          },
          {
            breakpoint: 601,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            },
          }
        ]

    });


     




    // FORM CONTACT LABEL ///

  $( ".wpcf7-form p.m_move label" ).click(function() {
      $( this ).parent().addClass('focus');
  });

  $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });





   /***************** ANIMATIONS *******************/


     const inview = gsap.utils.toArray('.gsap_inview');
      inview.forEach((btn) => {
        gsap.from(btn, {
          scrollTrigger: {
            trigger: btn,
            start: "top bottom",
                end: "center top",
            onEnter: function () {
                btn.classList.add("to_anim_trigger");
            },
            onEnterBack: function () {
                btn.classList.add("to_anim_trigger");
            },
            onLeave: function () {
                btn.classList.remove("to_anim_trigger");
            },
            onLeaveBack: function () {
                btn.classList.remove("to_anim_trigger");
            },

          }
        });
      });


     


     
     


});


